window.MAX_SUCCESS_CODE = 9998
